var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"padding-top":"55px"}}),_c('h1',[_vm._v(_vm._s(_vm.productName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }